(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sarjan-best-sellers"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.sarjan-bestsellers').forEach((section) => {
    const tablist = section.querySelector('[role="tablist"]');
    const tabs = Array.from(section.querySelectorAll('[data-sarjan-tab]'));
    const panels = section.querySelectorAll('[data-sarjan-panel]');
    if (!tabs.length) return;

    const activate = (tab, focus) => {
      tabs.forEach((t) => {
        const selected = t === tab;
        t.classList.toggle('is-active', selected);
        t.setAttribute('aria-selected', String(selected));
        t.tabIndex = selected ? 0 : -1;
      });
      panels.forEach((panel) => {
        panel.hidden = panel.dataset.sarjanPanel !== tab.dataset.sarjanTab;
      });
      if (focus) tab.focus();
    };

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => activate(tab, false));
    });

    if (tablist) {
      tablist.addEventListener('keydown', (e) => {
        const idx = tabs.indexOf(document.activeElement);
        if (idx === -1) return;
        let next = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = tabs[(idx + 1) % tabs.length];
        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = tabs[(idx - 1 + tabs.length) % tabs.length];
        if (e.key === 'Home') next = tabs[0];
        if (e.key === 'End') next = tabs[tabs.length - 1];
        if (next) {
          e.preventDefault();
          activate(next, true);
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sarjan-cart"]) return;
  try {
    
  document.querySelectorAll('[data-sarjan-promo]').forEach((form) => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const input = form.querySelector('[data-sarjan-promo-input]');
      const code = input && input.value.trim();
      if (code) {
        const cartUrl = (window.sarjanRoutes || {}).cart || '/cart';
        window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(cartUrl);
      }
    });
  });

  document.querySelectorAll('[data-sarjan-promo-note]').forEach((note) => {
    const match = document.cookie.match(/(?:^|;\s*)discount_code=([^;]+)/);
    if (!match) return;
    const code = decodeURIComponent(match[1]);
    if (!code) return;
    note.textContent = note.dataset.msg.replace('[code]', code);
    note.hidden = false;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sarjan-collection-grid"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-sarjan-price-filter]').forEach((form) => {
    const wrap = form.querySelector('.sarjan-shop__slider');
    if (!wrap) return;

    const rangeMax = parseInt(wrap.dataset.rangeMax, 10) || 100;
    const minThumb = form.querySelector('[data-slider-min]');
    const maxThumb = form.querySelector('[data-slider-max]');
    const fill = form.querySelector('[data-slider-fill]');
    const labelMin = form.querySelector('[data-slider-label-min]');
    const labelMax = form.querySelector('[data-slider-label-max]');
    const paramMin = form.querySelector('[data-slider-param-min]');
    const paramMax = form.querySelector('[data-slider-param-max]');

    const paint = () => {
      const sym = form.dataset.currency || '$';
      let lo = parseInt(minThumb.value, 10);
      let hi = parseInt(maxThumb.value, 10);
      if (lo > hi) { const t = lo; lo = hi; hi = t; }
      fill.style.left = (lo / rangeMax * 100) + '%';
      fill.style.right = (100 - hi / rangeMax * 100) + '%';
      labelMin.textContent = sym + lo;
      labelMax.textContent = sym + hi;
    };

    const apply = () => {
      let lo = parseInt(minThumb.value, 10);
      let hi = parseInt(maxThumb.value, 10);
      if (lo > hi) { const t = lo; lo = hi; hi = t; }
      paramMin.disabled = lo <= 0;
      paramMin.value = lo;
      paramMax.disabled = hi >= rangeMax;
      paramMax.value = hi;
      form.submit();
    };

    [minThumb, maxThumb].forEach((thumb) => {
      thumb.addEventListener('input', paint);
      thumb.addEventListener('change', apply);
    });
    paint();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sarjan-header"]) return;
  try {
    
  (() => {
    const header = document.querySelector('.sarjan-header');
    if (!header) return;

    header.querySelectorAll('[data-sarjan-mega-item]').forEach((item) => {
      const link = item.querySelector('a');
      let closeTimer;

      const open = () => {
        clearTimeout(closeTimer);
        item.classList.add('is-open');
        link.setAttribute('aria-expanded', 'true');
      };
      const close = () => {
        closeTimer = setTimeout(() => {
          item.classList.remove('is-open');
          link.setAttribute('aria-expanded', 'false');
        }, 120);
      };

      item.addEventListener('mouseenter', open);
      item.addEventListener('mouseleave', close);
      item.addEventListener('focusin', open);
      item.addEventListener('focusout', (e) => {
        if (!item.contains(e.relatedTarget)) close();
      });
    });

    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      header.querySelectorAll('[data-sarjan-mega-item].is-open').forEach((item) => {
        item.classList.remove('is-open');
        const link = item.querySelector('a');
        if (link) link.setAttribute('aria-expanded', 'false');
      });
    });

    const burger = header.querySelector('[data-sarjan-burger]');
    const mobileNav = header.querySelector('[data-sarjan-mobile-nav]');
    if (burger && mobileNav) {
      burger.addEventListener('click', () => {
        const isOpen = !mobileNav.hidden;
        mobileNav.hidden = isOpen;
        burger.setAttribute('aria-expanded', String(!isOpen));
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sarjan-newsletter"] && !Shopify.designMode) return;
  try {
    
  if (!window.sarjanNewsletterBound) {
    window.sarjanNewsletterBound = true;
    document.addEventListener('DOMContentLoaded', () => {
      const hash = window.location.hash;
      document.querySelectorAll('.sarjan-newsletter__form').forEach((form) => {
        if (!hash || hash === '#' + form.id) return;
        form.querySelectorAll('.sarjan-newsletter__message').forEach((msg) => msg.remove());
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sarjan-popup"]) return;
  try {
    
  if (!window.sarjanPopupBound) {
    window.sarjanPopupBound = true;
    document.addEventListener('DOMContentLoaded', () => {
      const dlg = document.getElementById('sarjan-popup');
      if (!dlg || typeof dlg.showModal !== 'function') return;
      if (window.Shopify && window.Shopify.designMode) return;
      const KEY = 'sarjanPopupUntil';
      const days = parseInt(dlg.dataset.days) || 7;
      const markSeen = (d) => {
        try { localStorage.setItem(KEY, String(Date.now() + d * 86400000)); } catch (e) {}
      };
      const posted = !dlg.querySelector('.sarjan-popup__fields');
      const ownPost = window.location.hash === '#sarjan-popup-form';
      const err = dlg.querySelector('.sarjan-popup__error');
      if (err && !ownPost) err.remove();
      let until = 0;
      try { until = parseInt(localStorage.getItem(KEY)) || 0; } catch (e) {}
      if (posted) {
        markSeen(365);
        if (ownPost) dlg.showModal();
      } else if (ownPost) {
        dlg.showModal();
      } else if (Date.now() > until) {
        setTimeout(() => {
          if (!document.querySelector('dialog[open]')) {
            dlg.showModal();
            markSeen(days);
          }
        }, (parseInt(dlg.dataset.delay) || 4) * 1000);
      }
      dlg.addEventListener('click', (e) => {
        if (e.target === dlg || e.target.closest('[data-sarjan-popup-close]')) dlg.close();
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sarjan-product"] && !Shopify.designMode) return;
  try {
    
window.sarjanCartAdd = window.sarjanCartAdd || function (formDataOrId, qty) {
  const drawer = document.querySelector('cart-drawer');
  let fd;
  if (formDataOrId instanceof FormData) {
    fd = formDataOrId;
  } else {
    fd = new FormData();
    fd.append('id', formDataOrId);
    fd.append('quantity', qty || 1);
  }
  const routes = window.sarjanRoutes || {};
  const useDrawer = drawer && typeof drawer.renderContents === 'function';
  if (useDrawer) {
    drawer.getSectionsToRender = () => [{ id: 'cart-drawer', selector: '#CartDrawer' }];
    fd.append('sections', 'cart-drawer');
    fd.append('sections_url', window.location.pathname);
  }
  return fetch(routes.cartAdd || '/cart/add', { method: 'POST', body: fd, headers: { Accept: 'application/javascript' } })
    .then((r) => r.json())
    .then((data) => {
      if (data.status && data.message) throw new Error(data.description || data.message);
      if (useDrawer) {
        drawer.classList.remove('is-empty');
        drawer.renderContents(data);
      }
      return fetch((routes.cart || '/cart') + '.js').then((r) => r.json());
    })
    .then((cart) => {
      const icon = document.getElementById('cart-icon-bubble');
      if (icon && cart) {
        let badge = icon.querySelector('.sarjan-header__cart-count');
        if (!badge && cart.item_count > 0) {
          badge = document.createElement('span');
          badge.className = 'sarjan-header__cart-count';
          badge.setAttribute('aria-hidden', 'true');
          icon.appendChild(badge);
        }
        if (badge) badge.textContent = cart.item_count;
      }
      return cart;
    });
};

class SarjanProduct extends HTMLElement {
  connectedCallback() {
    const sid = this.id.replace('sarjan-product-', '');
    const dataEl = document.getElementById('pdp-data-' + sid);
    if (!dataEl) return;

    const data = JSON.parse(dataEl.textContent);
    this._variants = data.variants;
    this._moneyFormat = data.moneyFormat;
    this._inventory = data.inventory;

    const current = this._variants.find(v => v.id === data.currentId);
    this._selectedOptions = current ? [...current.options] : [];

    this._bindThumbs(sid);
    this._bindSwatches(sid);
    this._bindPills(sid);
    this._bindQty(sid);
    this._bindDrawerAdd(sid);
    this._stickyGallery();
    this._bindStickyCta(sid);
  }

  _bindStickyCta(sid) {
    const bar = document.getElementById('pdp-sticky-' + sid);
    const atc = document.getElementById('pdp-atc-' + sid);
    const stickyAdd = document.getElementById('pdp-sticky-add-' + sid);
    if (!bar || !atc || !stickyAdd || !('IntersectionObserver' in window)) return;

    const io = new IntersectionObserver((entries) => {
      const e = entries[0];
      bar.hidden = !(e.boundingClientRect.top < 0 && !e.isIntersecting);
    });
    io.observe(atc);

    stickyAdd.addEventListener('click', () => atc.click());
  }

  _stickyGallery() {
    const gallery = this.querySelector('.sarjan-pdp__gallery');
    if (!gallery) return;

    const set = () => {
      if (!window.matchMedia('(min-width: 990px)').matches) {
        gallery.style.top = '';
        return;
      }
      const top = Math.min(104, window.innerHeight - gallery.offsetHeight - 24);
      gallery.style.top = top + 'px';
    };

    set();
    window.addEventListener('resize', set);
    gallery.querySelectorAll('img').forEach((img) => {
      if (!img.complete) img.addEventListener('load', set);
    });
  }

  _bindDrawerAdd(sid) {
    const form = this.querySelector('form[action*="/cart/add"]');
    const drawer = document.querySelector('cart-drawer');
    if (!form || !drawer) return;

    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const atc = document.getElementById('pdp-atc-' + sid);
      if (atc) atc.disabled = true;
      window
        .sarjanCartAdd(new FormData(form))
        .catch(() => { form.submit(); })
        .finally(() => { if (atc) atc.disabled = false; });
    });
  }

  _bindThumbs(sid) {
    const thumbs = this.querySelectorAll('.sarjan-pdp__thumb');
    const mainImg = document.getElementById('pdp-main-img-' + sid);
    if (!mainImg) return;

    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        thumbs.forEach(t => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
        const url = thumb.dataset.imgUrl;
        if (url) {
          mainImg.style.opacity = '0.5';
          mainImg.removeAttribute('srcset');
          mainImg.removeAttribute('sizes');
          mainImg.src = url;
          mainImg.onload = () => { mainImg.style.opacity = '1'; };
        }
      });
    });
  }

  _bindSwatches(sid) {
    this.querySelectorAll('.sarjan-pdp__swatch').forEach(swatch => {
      swatch.addEventListener('click', () => {
        const idx = parseInt(swatch.dataset.optionIndex);
        const val = swatch.dataset.optionValue;
        this._selectedOptions[idx] = val;

        const group = swatch.closest('[role="group"]');
        if (group) {
          group.querySelectorAll('.sarjan-pdp__swatch').forEach(s => {
            s.classList.remove('is-selected');
            s.setAttribute('aria-pressed', 'false');
          });
        }
        swatch.classList.add('is-selected');
        swatch.setAttribute('aria-pressed', 'true');

        const shadeVal = this.querySelector('#pdp-shade-label-' + sid + '-' + (idx + 1) + ' .sarjan-pdp__shade-value');
        if (shadeVal) shadeVal.textContent = val;

        this._updateVariant(sid);
      });
    });
  }

  _bindPills(sid) {
    this.querySelectorAll('.sarjan-pdp__pill').forEach(pill => {
      pill.addEventListener('click', () => {
        const idx = parseInt(pill.dataset.optionIndex);
        const val = pill.dataset.optionValue;
        this._selectedOptions[idx] = val;

        const group = pill.closest('[role="group"]');
        if (group) {
          group.querySelectorAll('.sarjan-pdp__pill').forEach(p => {
            p.classList.remove('is-selected');
            p.setAttribute('aria-pressed', 'false');
          });
        }
        pill.classList.add('is-selected');
        pill.setAttribute('aria-pressed', 'true');

        const optVal = pill.closest('.sarjan-pdp__option-selector').querySelector('.sarjan-pdp__option-value');
        if (optVal) optVal.textContent = val;

        this._updateVariant(sid);
      });
    });
  }

  _updateVariant(sid) {
    const match = this._variants.find(v =>
      v.options.every((opt, i) => opt === this._selectedOptions[i])
    );
    if (!match) return;

    const variantInput = document.getElementById('pdp-variant-id-' + sid);
    if (variantInput) variantInput.value = match.id;

    const priceEl = document.getElementById('pdp-price-' + sid);
    if (priceEl) {
      const currentEl = priceEl.querySelector('.sarjan-pdp__price-current');
      if (currentEl) currentEl.textContent = this._formatMoney(match.price);

      const compareEl = priceEl.querySelector('.sarjan-pdp__price-compare');
      if (match.compare_at_price && match.compare_at_price > match.price) {
        if (compareEl) {
          compareEl.textContent = this._formatMoney(match.compare_at_price);
          compareEl.style.display = '';
        }
      } else if (compareEl) {
        compareEl.style.display = 'none';
      }
    }

    const atcBtn = document.getElementById('pdp-atc-' + sid);
    if (atcBtn) atcBtn.disabled = !match.available;

    const stickyPrice = document.getElementById('pdp-sticky-price-' + sid);
    if (stickyPrice) stickyPrice.textContent = this._formatMoney(match.price);
    const stickyAdd = document.getElementById('pdp-sticky-add-' + sid);
    if (stickyAdd) stickyAdd.disabled = !match.available;

    const invBox = document.getElementById('pdp-inventory-' + sid);
    if (invBox) {
      const inv = (this._inventory || {})[match.id] || { qty: 0, tracked: false };
      const dot = invBox.querySelector('.sarjan-pdp__inventory-dot');
      const text = invBox.querySelector('.sarjan-pdp__inventory-text');
      invBox.hidden = !match.available;
      dot.classList.toggle('is-out', !match.available);
      if (inv.tracked && inv.qty > 0 && inv.qty <= 10) {
        text.textContent = invBox.dataset.msgCount.replace('[count]', inv.qty);
      } else if (match.available) {
        text.textContent = inv.tracked && inv.qty <= 0 ? invBox.dataset.msgBackorder : invBox.dataset.msgInStock;
      } else {
        text.textContent = invBox.dataset.msgSoldOut;
      }
    }

    if (match.featured_image && match.featured_image.src) {
      const mainImg = document.getElementById('pdp-main-img-' + sid);
      if (mainImg) {
        let src = match.featured_image.src;
        try {
          const u = new URL(src, window.location.origin);
          u.searchParams.set('width', '1200');
          src = u.toString();
        } catch (e) {}
        mainImg.style.opacity = '0.5';
        mainImg.removeAttribute('srcset');
        mainImg.removeAttribute('sizes');
        mainImg.src = src;
        mainImg.onload = () => { mainImg.style.opacity = '1'; };
      }
    }

    const url = new URL(window.location.href);
    url.searchParams.set('variant', match.id);
    window.history.replaceState({}, '', url.toString());
  }

  _formatMoney(cents) {
    const fmt = this._moneyFormat;
    const group = (num, thousands, decimal, decimals) => {
      const fixed = (cents / 100).toFixed(decimals);
      const parts = fixed.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return decimals > 0 ? parts[0] + decimal + parts[1] : parts[0];
    };
    if (!fmt) return '$' + group(cents, ',', '.', 2);
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, (m, key) => {
      switch (key) {
        case 'amount': return group(cents, ',', '.', 2);
        case 'amount_no_decimals': return group(cents, ',', '.', 0);
        case 'amount_with_comma_separator': return group(cents, '.', ',', 2);
        case 'amount_no_decimals_with_comma_separator': return group(cents, '.', ',', 0);
        case 'amount_with_space_separator': return group(cents, ' ', ',', 2);
        case 'amount_no_decimals_with_space_separator': return group(cents, ' ', ',', 0);
        case 'amount_with_apostrophe_separator': return group(cents, "'", '.', 2);
        default: return m;
      }
    });
  }

  _bindQty(sid) {
    const input = document.getElementById('pdp-qty-' + sid);
    const dec = document.getElementById('pdp-qty-dec-' + sid);
    const inc = document.getElementById('pdp-qty-inc-' + sid);
    if (!input || !dec || !inc) return;

    dec.addEventListener('click', () => {
      const v = parseInt(input.value) || 1;
      if (v > 1) input.value = v - 1;
    });
    inc.addEventListener('click', () => {
      input.value = (parseInt(input.value) || 1) + 1;
    });
  }
}
customElements.define('sarjan-product', SarjanProduct);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sarjan-returns"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const form = document.getElementById('sarjan-returns-form');
    if (!form) return;

    const stepOne = form.querySelector('[data-returns-step="1"]');
    const stepTwo = form.querySelector('[data-returns-step="2"]');
    const nextBtn = form.querySelector('[data-returns-next]');
    if (!stepOne || !stepTwo || !nextBtn) return;

    nextBtn.addEventListener('click', () => {
      const fields = stepOne.querySelectorAll('input');
      for (const field of fields) {
        if (!field.reportValidity()) return;
      }
      stepTwo.hidden = false;
      nextBtn.hidden = true;
      stepTwo.querySelector('input, textarea')?.focus();
    });

    const detailsLabel = form.querySelector('[data-returns-details-label]');
    form.querySelectorAll('input[name="contact[Reason]"]').forEach((radio) => {
      radio.addEventListener('change', () => {
        if (!detailsLabel) return;
        detailsLabel.textContent = radio.value === 'Damaged or defective'
          ? detailsLabel.dataset.labelDefective
          : detailsLabel.dataset.labelDidntLike;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sarjan-why-us"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.sarjan-whyus__layout').forEach((layout) => {
    const items = layout.querySelectorAll('[data-sarjan-why-index]');
    const panels = layout.querySelectorAll('[data-sarjan-why-panel]');

    items.forEach((item) => {
      item.addEventListener('click', () => {
        items.forEach((i) => {
          i.classList.toggle('is-active', i === item);
          i.setAttribute('aria-expanded', String(i === item));
        });
        panels.forEach((panel) => {
          panel.hidden = panel.dataset.sarjanWhyPanel !== item.dataset.sarjanWhyIndex;
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
